import Vue from 'vue'
import Vuex from 'vuex'

import { Chamber } from '@/models'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    chambers: [],
    lastId: -1
  },
  mutations: {
    add(state,payload){
      let chamber = payload.chamber;
      Vue.set(state.chambers,chamber.id,chamber);
      state.lastId = chamber.id;
    },
  },
  actions: {
    createAndAdd({state,commit,dispatch},payload) {
      let c = new Chamber();
      c.name = payload.chamber.name;
      c.route = payload.chamber.route;
      c.id = state.lastId+1;
      c.idTheme = payload.idTheme;
      commit('add', {chamber: c});
      payload.chamber.sources.forEach((s) => {
        dispatch('sources/createAndAdd',{source: s, idChamber: c.id}, {root: true})
      });
    },
  },
  getters: {
    getAll: (state) => {
      return state.chambers;
    },
    chambersByThemeId: (state) => (idTheme) => {
      return state.chambers.filter(c => c.idTheme == idTheme)
    },
    chamberByRoute: (state) => (route) => {
      return state.chambers.find(c => c.route == route)
    },
    chambersByRoutes: (state,getters) => (routes) => {
      let chambers = []
      routes.forEach((route) => {
        chambers.push(getters.chamberByRoute(route));
      });
      return chambers;
    },
  },
  modules: {
  }
}
